import {
    getCoatingColours,
    ListingBuyerModel,
    ListingSellerModel,
    DownloadFile,
    UploadFile,
    formatNumberForDimensions,
} from '@steelbuy/ts-shared';
import { ListingDetailsMaterial, ListingDetailsQuality, ListingDetailsDimensions } from '@steelbuy/ui-domain';
import { constants } from '../../constants';

export const CommonListingDetails = ({
    listingModel,
    internalSellerSku,
    showRequestCertificateCta,
    showAge = true,
    updateListingCache,
}: {
    listingModel: ListingBuyerModel | ListingSellerModel;
    internalSellerSku?: string;
    showRequestCertificateCta?: boolean;
    showAge?: boolean;
    updateListingCache?: (properties: Partial<ListingBuyerModel>) => void;
}) => (
    <>
        <ListingDetailsDimensions
            tolerance={'tolerance' in listingModel.material ? listingModel.material.tolerance : undefined}
            thickness={formatNumberForDimensions(listingModel.materialDimensions.thickness) || null}
            width={formatNumberForDimensions(listingModel.materialDimensions.width) || null}
            length={
                'length' in listingModel.materialDimensions
                    ? formatNumberForDimensions(listingModel.materialDimensions.length)
                    : undefined
            }
            gauge={listingModel?.gauge ? listingModel.gauge : undefined}
            thicknessType={listingModel.materialDimensions.thicknessType}
        />
        <ListingDetailsMaterial
            {...listingModel.material}
            age={showAge ? listingModel.age : undefined}
            origin={[listingModel.origin]}
            prime={listingModel.prime}
            quality={listingModel.quality}
            sku={internalSellerSku}
            coatingColours={getCoatingColours(listingModel.material, true)}
            countryCode={(listingModel as ListingBuyerModel).country}
            state={(listingModel as ListingBuyerModel)?.state}
        />
        {listingModel.prime ? (
            <ListingDetailsQuality
                prime={listingModel.prime}
                testCertificate={listingModel.testCertificate ? [listingModel.testCertificate] : []}
                description={listingModel.description}
                apiBaseUrl={constants.apiBaseUrl}
                listingId={listingModel.id}
                hasRequestedCertificate={listingModel?.hasRequestedCertificate}
                showRequestCertificateCta={showRequestCertificateCta}
                updateListingCache={updateListingCache}
            />
        ) : (
            <ListingDetailsQuality
                prime={listingModel.prime}
                picture={listingModel.picture ? [listingModel.picture] : null}
                testCertificate={
                    listingModel.testCertificate
                        ? [(listingModel as ListingSellerModel).testCertificate as DownloadFile | UploadFile]
                        : null
                }
                description={listingModel.description}
                apiBaseUrl={constants.apiBaseUrl}
                listingId={listingModel.id}
            />
        )}
    </>
);
